/* v8 ignore start */
import React from 'react';
import PropTypes from 'prop-types';

import BaseWizard from 'containers/BaseWizard';
import SimpleSidebar from 'containers/BaseWizard/components/Sidebars/SimpleSidebar';

import ExamplePage from './ExamplePage';

const PATH = 'Path Two';
const cancelModalProps = {
  title: `${PATH} Modal`,
  confirmText: 'Delete',
  confirmStyle: 'delete',
};

const WizardPathTwo = ({ wizardStore, handleClose, resetPath }) => {
  return (
    <BaseWizard
      cancelModalProps={cancelModalProps}
      enableCancelModal
      enableFooter
      buttonText="Done"
      onFooterBack={resetPath}
      wizardStore={wizardStore}
      sidebarComponent={<SimpleSidebar title={`${PATH} Sidebar`} />}
      onClose={handleClose}
    >
      <ExamplePage
        title={`${PATH} Page One`}
        pageHeader={`${PATH} Page One Header`}
      />
      <ExamplePage
        title={`${PATH} Page Two Page Two but this is longer and wraps`}
        pageHeader={`${PATH} Page Two Header`}
      />
    </BaseWizard>
  );
};

WizardPathTwo.propTypes = {
  wizardStore: PropTypes.object,
  handleClose: PropTypes.func,
  resetPath: PropTypes.func
};

export default WizardPathTwo;
